import React, { useState } from 'react';
import { Box, Button, Grid, Paper, TextField, InputLabel, MenuItem } from '@mui/material';
import { Language } from '../interfaces/language';
import { useTranslation } from 'react-i18next';

interface LanguageSelectionFormProps {
  languages?: ReadonlyArray<Language>;
  onLanguageSubmit?(selectedLanguage: Language): void;
}

const LanguageSelectionForm = (props: LanguageSelectionFormProps): React.JSX.Element => {
  const { languages, onLanguageSubmit } = props;
  const { t } = useTranslation();
  const defaultLanguage =
    languages && (languages.find((lang) => lang.default) || (languages.length === 1 && languages[0]));

  const [language, setLanguage] = useState(defaultLanguage || { isoCode: '' });

  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    setLanguage({ isoCode: value });
  };

  const handleSubmit = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    // TODO: validation if required
    if (language.isoCode && onLanguageSubmit) {
      const selectedLanguage = languages && languages.find((lang) => lang.isoCode === language.isoCode);
      selectedLanguage && onLanguageSubmit(selectedLanguage);
    }
  };

  return (
    <Paper>
      <Box p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputLabel htmlFor="assessmentLanguage">
                <strong>{t('selectLanguage')}</strong>
              </InputLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="assessmentLanguage"
                select
                fullWidth
                size="small"
                inputProps={{ 'aria-label': t('selectLanguage'), id: 'assessmentLanguage' }}
                value={language.isoCode}
                onChange={handleLanguageChange}
                required>
                {languages &&
                  languages.map((option) => (
                    <MenuItem key={option.id} value={option.isoCode}>
                      {option.label ? option.label : option.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
          </Grid>

          <Box pt={4} textAlign="center">
            <Button type="submit" variant="outlined" color="primary">
              <div>{t('continue')}</div>
            </Button>
          </Box>
        </form>
      </Box>
    </Paper>
  );
};

export default LanguageSelectionForm;
